import classes from '../styles/Home.module.scss';
import client from './api/graphql';
import { GET_HOME_CONTENT } from './api/graphql/queries';
import BannerHero from '../components/sections/bannerHero/BannerHero';
import Features from '../components/sections/featuresSection/Features';
import GetAyoba from '../components/sections/getAyoba/GetAyoba';
import GettingStarted from '../components/sections/gettingStarted/GettingStarted';
import Testimonials from '../components/sections/testimonials/Testimonials';
import Newsroom from '../components/sections/newsroom/Newsroom';
import ContactUs from '../components/sections/contactUs/ContactUs';
import FeaturesHome from '../components/sections/features/FeaturesHome';

/**
 * Ayoba Web Home Page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Home = (props) => {
    const { homePage } = props?.data;

    /**
     * Section content
     */
    const {
        banner_hero,
        pwa_region,
        features,
        get_ayoba,
        getting_started,
        testimonials,
        newsroom,
        contact_us
    } = homePage?.data?.attributes;

    console.log('pwa_region', pwa_region);

    return (
        <div className={classes.oPageHome}>
            <BannerHero {...banner_hero} overlayState="hasOverlay" hasBackgroundColorBlobs={true} />
            <FeaturesHome {...pwa_region} />
            <div style={{ display: 'none' }}>
                <Features {...features} />
            </div>
            <GetAyoba {...get_ayoba} hasBackgroundColorBlobs={true} />
            <GettingStarted {...getting_started} />
            <Testimonials {...testimonials} />
            <Newsroom {...newsroom} isSection={true} />
            <ContactUs {...contact_us} />
        </div>
    );
};

export async function getServerSideProps(context) {
    const locale = context.query?.lang || context.defaultLocale;

    const { data, errors } = await client.query({
        query: GET_HOME_CONTENT,
        variables: { _locale: locale }
    });

    if (errors) console.log('errors:', errors);

    return {
        props: { data }
    };
}

export default Home;
